import { getAccessToken } from './authUtils';

export default async function downloadFile(url: string, filename: string) {
  const response = await fetch(url, {
    method: 'get',
    credentials: 'include',
    headers: {
      authorization: `Bearer ${getAccessToken()}`,
    },
  });

  if (response.ok) {
    const file = await response.blob();
    download(file, filename);
  } else {
    throw new Error(
      'Failed to download report, Please contact Alef support if this problem persists',
    );
  }
}

const download = (data: Blob, fileName: string) => {
  if (data === null) return;
  const link = document.createElement('a');
  const url = window.URL.createObjectURL(data);
  link.setAttribute('href', url);
  link.setAttribute('download', fileName);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
